<template>
  <div class="AudioReport">
    <v-container grid-list-md fluid fill-height>
      <v-layout wrap align-start justify-center row fill-height>
        <v-flex xs12>
          <v-card>
            <v-expansion-panel
              v-model="panel"
              expand
              popout
            >
              <v-expansion-panel-content>
                <template v-slot:header>
                  <v-card-title class="title">
                    Preguntas del operativo: {{ operName }}
                  </v-card-title>
                </template>

                <v-card>
                  <v-card-text>
                    <v-layout wrap align-center  justify-space-around row fill-height>
                      <v-flex xs12 md3>
                        <v-menu
                          :close-on-content-click="false"
                          v-model="menuIni"
                          transition="scale-transition"
                          offset-y
                          full-width
                          :nudge-right="40"
                          max-width="290px"
                          min-width="290px"
                        >
                          <v-text-field
                            slot="activator"
                            label="Fecha Inicial"
                            v-model="dateIni"
                            prepend-icon="event"
                            readonly
                            hint="Debe ser anterior a la fecha final"
                            persistent-hint
                          ></v-text-field>
                          <v-date-picker
                            v-model="dateIni"
                            locale="es-CO"
                            no-title
                            scrollable
                            actions
                          ></v-date-picker>
                        </v-menu>
                      </v-flex>

                      <v-spacer/>

                      <v-flex xs12 md3>
                        <v-menu
                          :close-on-content-click="false"
                          v-model="menuEnd"
                          transition="scale-transition"
                          offset-y
                          full-width
                          :nudge-right="40"
                          max-width="290px"
                          min-width="290px"
                        >
                          <v-text-field
                            slot="activator"
                            label="Fecha Final"
                            v-model="dateEnd"
                            prepend-icon="event"
                            readonly
                            hint="Debe ser posterior a la fecha inicial"
                            persistent-hint
                          ></v-text-field>
                          <v-date-picker
                            v-model="dateEnd"
                            locale="es-CO"
                            no-title
                            scrollable
                            actions
                          ></v-date-picker>
                        </v-menu>
                      </v-flex>

                      <v-spacer/>
                    </v-layout>
                    <v-layout wrap align-center justify-space-around row fill-height>
                      <v-flex xs12 sm2 md3 >
                        <v-select
                          :items="itemsAgentes"
                          label="Agente"
                          v-model="agente"
                        ></v-select>
                      </v-flex>
                       <v-flex xs12 sm2  md3 >
                        <v-select
                          :items="itemsIncidencias"
                          label="Incidencias"
                          v-model="incidencia"
                        ></v-select>
                      </v-flex>
                    </v-layout>

                  </v-card-text>

                  <v-card-text>

                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>

            <v-card-actions>
              <v-spacer></v-spacer>

              <v-btn color="warning"
                :disabled="loading"
                @click="clear()"
              >
                Limpiar
              </v-btn>
              <v-btn color="info"
                :disabled="loading"
                @click="getPolls()"
              >
                Cargar Audios
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>

        <v-flex xs12 md5>
          <v-card class="mb-2">
            <v-card-title class="title">
              <v-text-field
                v-if="!loading && dataVals.length !== 0"
                v-model="search"
                append-icon="search"
                label="Buscar"
                single-line
                hide-details
              ></v-text-field>
            </v-card-title>
            <v-card-text
              v-if="loading"
              class="text-xs-center"
            >
            <v-progress-circular
              :size="progressSize"
              :width="progressWidth"
              indeterminate
              color="info"
            ></v-progress-circular>
            </v-card-text>

            <v-card-text v-else>
              <v-data-table
                dense
                :headers="headers"
                :items="dataVals"
                :search="search"
                no-results-text="No se encontro el término buscado"
                no-data-text="No hay datos disponibles"
                multi-sort
                disable-initial-sort
                class="elevation-1"
                loading="Cargando... Por favor espere."
                :key="tableKey"
              >
                <template v-slot:items="props">
                  <td v-if="props.item.lead_id === IDEncuesta">
                    <strong> {{ props.item.lead_id }} </strong>
                  </td>
                  <td v-else>
                    {{ props.item.lead_id }}
                  </td>
                  <td class="justify-space-around">
                    <v-layout align-center justify-space-around>
                      <v-icon
                        color="info"
                        @click="loadPoll(props.item.lead_id, props.item.audios)"
                      >
                        queue_music
                      </v-icon>
                    </v-layout>
                  </td>
                  <!-- <td>
                    <v-layout align-center justify-space-around>
                      <v-icon
                        color="success"
                        @click="editPoll(props.item, '0')"
                      >
                        check_circle
                      </v-icon>
                      <v-icon
                        color="error"
                        @click="editPoll(props.item, '2')"
                      >
                        cancel
                      </v-icon>
                    </v-layout>
                  </td> -->
                </template>
              </v-data-table>
            </v-card-text>

            <!-- <v-dialog v-model="dialog" max-width="500px">
              <v-card>
                <v-card-title>
                  <span class="headline">Validar Audio</span>
                </v-card-title>

                <v-card-text>
                  Esta acción no se puede deshacer
                  <v-checkbox
                    v-model="checkbox"
                    label="Confirmo que deseo validar el audio"
                  ></v-checkbox>
                </v-card-text>

                <v-alert :value="alert" type="error">
                  No se ha podido realizar la validación
                </v-alert>

                <v-card-actions>
                  <v-spacer/>
                  <v-btn color="info" @click="close">Cancelar</v-btn>
                  <v-btn
                    :disabled="!this.checkbox"
                    color="warning"
                    @click="save"
                  >Enviar</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog> -->
          </v-card>
        </v-flex>

        <v-flex xs12 md7>
          <v-card class="mb-2" v-if="IDEncuesta !== null">
            <v-card-title class="title">
              Audios Relacionados
              {{ IDEncuesta }}
            </v-card-title>

            <v-card-text
              v-if="loadingRecords"
              class="text-xs-center"
            >
              <v-progress-circular
                :size="progressSize"
                :width="progressWidth"
                indeterminate
                color="info"
              ></v-progress-circular>
            </v-card-text>

            <v-card-text v-else>
              <v-data-table
                dense
                :headers="headersRecords"
                :items="dataValsRecords"
                no-results-text="No se encontro el término buscado"
                no-data-text="No hay datos disponibles"
                multi-sort
                disable-initial-sort
                class="elevation-1"
                loading="Cargando... Por favor espere."
                :key="tableRecordsKey"
                item-key="recording_id"
              >
                <template v-slot:items="props">
                  <tr @click="props.expanded = !props.expanded">
                    <td> {{ props.item.recording_id }} </td>
                    <td> {{ props.item.date }} </td>
                    <td> {{ props.item.user }} </td>
                    <td class="justify-space-around">
                      <v-layout align-center justify-space-around>
                        <v-icon color="info">audiotrack</v-icon>
                      </v-layout>
                    </td>
                  </tr>
                </template>

                <template v-slot:expand="props">
                  <v-card flat>
                    <audio controls>
                      <source :src="props.item.url">
                      Tu navegador no soporta el audio.
                    </audio>
                  </v-card>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: `AudioReport`,

  /**
   * Esta función carga el respectivo Layout, al crear la vista.
   */
  created () {
    this.$store.commit('SET_LAYOUT', 'dashboard-layout')
    this.operativo = this.$store.state.actualOperation.id
    this.getPolls()
    this.getFiltros()
  },

  data: function () {
    return {
      backConf: {
        path: '/callcenter/osdial-audios',
        page: 1
      },

      operativo: null,

      search: '',
      dialog: false,
      loading: false,
      loadingRecords: false,
      progressSize: 70,
      progressWidth: 7,
      progressTotal: 0,
      progressAdvance: 0,
      completed: 0,

      panel: [true],
      dateIni: null,
      dateEnd: null,

      alert: false,

      headers: [
        {
          text: 'Numero Marcado',
          value: 'lead_id',
          align: 'left'
        },
        { text: 'Audios', value: '', align: 'center', sortable: false }
        // { text: 'Acciones', value: '', align: 'center', sortable: false }
      ],
      dataVals: [],
      tableKey: 0,

      headersRecords: [

        {
          text: 'Id. llamada',
          value: 'recording_id',
          align: 'left'
        },
        {
          text: 'Fecha',
          value: 'date',
          align: 'left'
        },
        {
          text: 'Agente',
          value: 'user',
          align: 'left'
        },
        { text: 'Incidencia', value: 'inc', align: 'center' },
        { text: 'Escuchar', value: 'url', align: 'center', sortable: false }
      ],
      dataValsRecords: null,
      tableRecordsKey: 0,

      editedIndex: -1,
      editedPoll: {},
      IDEncuesta: null,
      checkbox: false,
      incidenceType: null,

      itemsIncidencias: [],
      itemsAgentes: [],

      incidencia: null,
      agente: null

    }
  },

  watch: {
    '$store.state.actualOperation': function () {
      this.operativo = this.$store.state.actualOperation.id
    },

    dialog (val) {
      val || this.close()
    },

    'dataVals': function () {
      this.completed = (this.progressAdvance / this.progressTotal) * 100
    }
  },

  computed: {
    /**
     * Verifica que la fecha final no sea anterior a la fecha inicial
     */
    vDate: function vDate () {
      if (this.dateIni && this.dateEnd) {
        return moment(this.dateEnd).isBefore(this.dateIni)
      }
      return false
    }
  },

  methods: {
    /** Carga los filtros Incidencias y Agentes para la peticion

    */
    getFiltros () {
      let request = {
        method: 'get',
        url: this.backConf.pathFiltros,
        params: {
          operativo: this.operativo
        }
      }

      let t = this
      this.$store.dispatch('request_back', request)
        .then(function (resp) {
          t.itemsIncidencias = resp.data[0]
          t.itemsAgentes = resp.data[1]
        })
        .catch(function (err) {
          t.itemsIncidencias = []
          t.itemsAgentes = []
          console.error(err)
        })
    },

    /** Carga la información de las llamadas
     */
    getPolls () {
      this.loading = true
      this.panel = [false]

      let request = {
        method: 'get',
        url: this.backConf.path,
        params: {
          operativo: this.operativo,
          efectivo: this.$store.state.actualRole === 'CL'
        }
      }

      if (this.fechaIni != null) {
        request.params['fechaIni'] = this.fechaIni
      }

      if (this.fechaFin != null) {
        request.params['fechaFin'] = this.fechaFin
      }
      if (this.agente != null) {
        request.params['agente'] = this.agente
      }
      if (this.incidencia != null) {
        request.params['incidencia'] = this.incidencia
      }

      let t = this
      this.$store.dispatch('request_back', request)
        .then(function (resp) {
          t.progressAdvance = t.dataVals.length
          t.dataVals = resp.data[0]
          t.loading = false
        })
        .catch(function (err) {
          t.dataVals = []
          t.loading = false
          t.backConf.page = 1
          console.error(err)
        })

      t.tableKey += 1
    },

    /** Carga los audios relacionadops a la encuesta
     * @param  {string} IDEncuesta El identificador de la encuesta seleccionada
     * @param  {Array} audiosRel   Lista de audios de la encuesta seleccionada
     */
    loadPoll (IDEncuesta, audiosRel) {
      if (!this.loadingRecords) {
        this.dataValsRecords = []
      }

      this.loadingRecords = true
      this.IDEncuesta = IDEncuesta
      this.dataValsRecords = audiosRel
      this.loadingRecords = false

      // let length = this.dataVals.length
      // for (var i = 0; i < length; i++) {
      //   if (this.dataVals[i].lead_id === IDEncuesta) {
      //     this.dataValsRecords = this.dataVals[i].audios
      //     this.loadingRecords = false
      //     break
      //   }
      // }
    },

    /** Selecciona al encuesta a validar
     * @param  {object} poll encuesta a validar
     * @param  {char} inc  tipo de incidencia
     */
    editPoll (poll, inc) {
      this.editedIndex = this.dataVals.indexOf(poll)
      this.incidenceType = inc
      this.editedPoll = Object.assign({}, poll)
      this.dialog = true
    },

    /** Limpia el formulario de validación y limpia los elementos asociados
     */
    close () {
      this.dialog = false
      this.incidenceType = null
      this.checkbox = false
      this.alert = false

      setTimeout(() => {
        this.editedPoll = {}
        this.editedIndex = -1
      }, 300)
    },

    /** envia la validación,
     * actualiza la tabla local
     */
    save () {
      let request = {
        method: 'patch',
        data: {
          id: this.editedPoll.encuesta,
          calificacion: this.incidenceType
        },
        url: this.backConf.path
      }

      let t = this
      this.$store.dispatch('request_back', request)
        .then(function (resp) {
          t.dataVals.splice(t.editedIndex, 1)
          t.alert = false
          t.close()
        })
        .catch(function (err) {
          t.alert = true
          console.error(err)
        })
    },

    /**
     * Limpia todos los campos
     */
    clear () {
      this.dataVals = []
      this.dataValsRecords = null
      this.dateIni = null
      this.dateEnd = null
      this.panel = [true]
    }
  }
}

</script>

<style scoped>
  audio {
    width: 100%;
  }
</style>
